import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Paper, Skeleton } from '@mui/material';
import ArticleModalHeader from './ArticleModalHeader';

const ArticleModalLoadingContent = ({ article, onClose }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} md={8.52}>
      <ArticleModalHeader
        article={article}
        loading
        onBack={onClose}
        onClose={onClose}
      />

      <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 2, mb: 3 }} />
      <Skeleton variant="text" width={150} height={20} sx={{ mb: 2 }} />
      <Box sx={{ my: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="95%" height={20} />
      </Box>
      <Skeleton variant="text" width="100%" height={24} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="98%" height={24} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="95%" height={24} sx={{ mb: 1 }} />
      <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
        <Skeleton variant="rounded" width={70} height={28} />
        <Skeleton variant="rounded" width={90} height={28} />
      </Box>
    </Grid>

    <Grid item xs={12} md={3.48}>
      <Paper elevation={1} sx={{ p: 2, mb: 2, border: 1, borderColor: 'divider' }}>
        <Skeleton variant="text" width={120} height={28} sx={{ mb: 2 }} />
        {[...Array(6)].map((_, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
        ))}
      </Paper>
      <Paper elevation={1} sx={{ p: 2, border: 1, borderColor: 'divider' }}>
        <Skeleton variant="text" width={80} height={28} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={36} sx={{ mb: 1, borderRadius: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={36} sx={{ mb: 1, borderRadius: 1 }} />
        <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: 1 }} />
      </Paper>
    </Grid>
  </Grid>
);

ArticleModalLoadingContent.propTypes = {
  article: PropTypes.shape({
    mediaType: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default ArticleModalLoadingContent;
